import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { FileFieldsInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiOperation, ApiParam, ApiTags } from '@nestjs/swagger';
import { imageFileFilter } from '../shared/file-upload';
import { SettingsResponseModel } from './dto/settings-response.model';
import { SettingsDto } from './dto/settings.dto';
import { SettingsService } from './settings.service';
import { extname } from 'path';
import { diskStorage } from 'multer';

@ApiTags('Settings')
@Controller('settings')
export class SettingsController {
    constructor (
        private settingsService: SettingsService
    ) {}

   
    @Post('/save')
    @ApiOperation({summary:'create or update app settings'})
    @UseInterceptors(	
            FileFieldsInterceptor([{
              name:'iconattachments', maxCount: 1,
            },{name:'spalshattachments', maxCount: 1},],
            {
                    fileFilter: imageFileFilter,
                    storage: diskStorage({
                        destination: './public/appPic',
                        filename: function (req, file, callback) {
                            const name = file.originalname.split('.')[0];
                            const fileExtName = extname(file.originalname);
                            const randomName = Array(4)
                                .fill(null)
                                .map(() => Math.round(Math.random() * 16).toString(16))
                                .join('');
                            callback(null, `${name}-${randomName}${fileExtName}`);
                        }
                    }),			
                }),	
          )
    @ApiConsumes('multipart/form-data')
    async create(@UploadedFiles() files, @Body() sDTO:SettingsDto, @Req() request: Request): Promise<SettingsResponseModel> {
        try {
            const response = [];
            const response1 = [];
            if(files.iconattachments) {
              files.iconattachments.forEach(file => {
                const fileReponse =  `settings/appPic/${file.filename}`;
               response.push(fileReponse);
              })
            }
            if(files.spalshattachments) {
              files.spalshattachments.forEach(file => {
                const fileReponse =  `settings/appPic/${file.filename}`;
               response1.push(fileReponse);
              })
            }      
            return await this.settingsService.createNew(response,response1,sDTO, request);
        } catch (error) {
            return errorHandler(SettingsResponseModel, error);
        }
    }

    @Post('/update')
    @ApiOperation({summary:'create or update app settings'})
    @UseInterceptors(	
            FileFieldsInterceptor([{
              name:'iconattachments', maxCount: 1,
            },{name:'spalshattachments', maxCount: 1},],
            {
                    fileFilter: imageFileFilter,
                    storage: diskStorage({
                        destination: './public/appPic',
                        filename: function (req, file, callback) {
                            const name = file.originalname.split('.')[0];
                            const fileExtName = extname(file.originalname);
                            const randomName = Array(4)
                                .fill(null)
                                .map(() => Math.round(Math.random() * 16).toString(16))
                                .join('');
                            callback(null, `${name}-${randomName}${fileExtName}`);
                        }
                    }),			
                }),	
          )
    @ApiConsumes('multipart/form-data')
    async update(@UploadedFiles() files, @Body() sDTO:SettingsDto, @Req() request: Request): Promise<SettingsResponseModel> {
        try {
            const response = [];
            const response1 = [];
            if(files.iconattachments) {
              files.iconattachments.forEach(file => {
                const fileReponse =  `settings/appPic/${file.filename}`;
               response.push(fileReponse);
              })
            }
            if(files.spalshattachments) {
              files.spalshattachments.forEach(file => {
                const fileReponse =  `settings/appPic/${file.filename}`;
               response1.push(fileReponse);
              })
            }      
            return await this.settingsService.updateOld(response,response1,sDTO, request);
        } catch (error) {
            return errorHandler(SettingsResponseModel, error);
        }
    }

    @Get('/appPic/:imgpath')
    @ApiParam({name:'imgpath'})
    async seeUploadedPic(@Param('imgpath') Image, @Res() res) {
		try {
			return res.sendFile(Image, { root: './public/appPic' });
		} catch (error) {
			return error.message;
		}
    }


    @Get('/getSettings')
   async getSettings(@Req() request:Request):Promise<SettingsResponseModel> {
        try {
            return await this.settingsService.getSettings();
        } catch (error) {
            return errorHandler(SettingsResponseModel, error);
        }
    }
}


